// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useState, useEffect, useContext} from 'react';
import {useLocation} from 'react-router-dom';
import date from 'zdate';
import {perr} from 'hola_pub_util';
import etask from 'zetask';
import {qs_str} from 'zurl';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_debug_ui} from '../../lib/debug';
import hopt from 'hola_opt';
// @ts-ignore
import {set, get} from '/util/storage.js';
import {use_login} from '../navbar_hola2023/use_login';
import {App_context} from 'hola_app_context';

const base_date = new Date('2025-11-18');
const end_date = date.add(base_date, {month: 3});
export const SA2025_EXPIRATION_DATE = date.strftime('%B %d, %Y', end_date);
const PATH_SA2025 = '/sa-2025';

type t_fetch_sa2025_redeem_token_params =
    | {token: string, hola_uid: string}
    | {token: string, email: string, hola_uid?: string};

export const fetch_sa2025_redeem_token = (params:
    t_fetch_sa2025_redeem_token_params)=>
    etask(function*(){
        yield fetch('https://hola.org/users/sa2025_redeem_token', {
            method: 'POST',
            body: params,
            headers: {'Content-Type': 'application/json'},
        });
    });

export const fetch_sa2025_token = (hola_uid: string)=>
    etask(function*(){
        const res = yield fetch(
            'https://client.hola.org/client_cgi/sa2025_token', {
            method: 'POST',
            body: {hola_uid},
            headers: {'Content-Type': 'application/json'},
        });
        return res;
    });

export const use_settlement_notification = ()=>{
    const {pathname} = useLocation();
    const {user} = useContext(App_context) as any;
    const {show_login_form} = use_login(false, '/');
    const [is_client, set_is_client] = useState(false);
    const [settlement_opened, set_settlement_opened] = useState(false);
    const [login_popup_opened, set_login_popup_opened] = useState(false);
    const [done_popup_opened, set_done_popup_opened] = useState(false);
    const is_homepage = pathname=='/';
    const debug_sa2025 = use_debug_ui('sa2025');
    const show_sa2025 = debug_sa2025 || hopt.www_hola?.sa2025?.enable;
    const [benefit_type, benefit_value] = user?.sa2025 || [];
    const is_duplicate = benefit_type=='duplicate';
    const sa2025_done = get('sa2025_done');
    const notification_visible = is_client && is_homepage && show_sa2025
        && !sa2025_done;
    useEffect(()=>{
        if (notification_visible)
            perr({id: 'www_sa2025_notification_bar_show'});
    }, [notification_visible]);
    useEffect(()=>{
        set_is_client(true);
        const sa2025_act_ts = get('sa2025_act');
        if (sa2025_act_ts && user)
        {
            const elapsed = Date.now() - parseInt(sa2025_act_ts, 10);
            if (elapsed < 5*60*1000)
            {
                set('sa2025_act', null);
                if (is_duplicate)
                    set_done_popup_opened(true);
                else
                    set_settlement_opened(true);
            }
        }
    }, [user, is_duplicate]);
    const on_learn_more_click = ()=>{
        if (!user)
        {
            set_login_popup_opened(true);
            perr({id: 'www_sa2025_login_popup_show'});
            return;
        }
        if (is_duplicate)
        {
            set_done_popup_opened(true);
            perr({id: 'www_sa2025_done_popup_show'});
            return;
        }
        set_settlement_opened(true);
        perr({id: 'www_sa2025_settlement_popup_show'});
    };
    const on_close = ()=>{
        set_settlement_opened(false);
        perr({id: 'www_sa2025_settlement_popup_closed'});
    };
    const on_done_popup_close = ()=>{
        set_done_popup_opened(false);
        perr({id: 'www_sa2025_done_popup_closed'});
    };
    const on_got_it = ()=>{
        set('sa2025_done', 'true');
        set_done_popup_opened(false);
        perr({id: 'www_sa2025_done_popup_got_it'});
    };
    const on_login_popup_close = ()=>{
        set_login_popup_opened(false);
        perr({id: 'www_sa2025_login_popup_closed'});
    };
    const on_login_popup_signin = ()=>{
        set('sa2025_act', Date.now().toString());
        set_login_popup_opened(false);
        perr({id: 'www_sa2025_login_popup_signin_clicked'});
        show_login_form();
    };
    const on_receive_benefit = ()=>{
        perr({id: 'www_sa2025_settlement_popup_click_receive'});
        etask(function*(){
            try {
                const res = yield fetch_sa2025_token(user.hola_uid);
                const token = res.token;
                const [token_type, token_value] = res.token_action || [];
                if (!token || !token_type)
                {
                    perr({id: 'www_sa2025_settlement_popup_no_token'});
                    return;
                }
                set_settlement_opened(false);
                perr({id: 'www_sa2025_settlement_popup_benefit_received'});
                const qs_params: any = {type: token_type, token,
                    hola_uid: user.hola_uid};
                if (token_type=='membership')
                    qs_params.days = token_value;
                if (token_type=='refund')
                    qs_params.email = user.emails?.[0]?.value || '';
                window.location.href = PATH_SA2025+'?'+qs_str(qs_params);
            } catch(e){
                perr({id: 'www_sa2025_settlement_popup_token_error',
                    info: {error: e.message}});
            }
        });
    };
    return {
        notification_visible,
        on_learn_more_click,
        is_open: settlement_opened,
        benefit_type,
        benefit_value,
        on_close,
        on_receive_benefit,
        is_client,
        login_popup_is_open: login_popup_opened,
        login_popup_on_close: on_login_popup_close,
        login_popup_on_signin: on_login_popup_signin,
        done_popup_is_open: done_popup_opened,
        done_popup_on_close: on_done_popup_close,
        done_popup_on_got_it: on_got_it,
    };
};

interface i_use_refund_confirmation_props {
    email: string;
    token: string;
    hola_uid?: string;
    on_confirmed: ()=>void;
    on_error: (error_type: string)=>void;
}
export const use_refund_confirmation = (props:
    i_use_refund_confirmation_props)=>{
    const {email, token, hola_uid, on_confirmed, on_error} = props;
    const perr_info = {email, token, hola_uid};
    const [is_loading, set_is_loading] = useState(false);
    const on_confirm_refund = ()=>{
        perr({id: 'www_sa2025_refund_confirmation_click_confirm',
            info: perr_info});
        set_is_loading(true);
        etask(function*(){
            try {
                yield fetch_sa2025_redeem_token({email, token, hola_uid});
                perr({id: 'www_sa2025_refund_confirmation_confirmed',
                    info: perr_info});
                on_confirmed();
            } catch(e){
                let error_type = 'general_error';
                const hola_info = e.hola_info || {};
                if (hola_info.response_text)
                {
                    const error_data = JSON.parse(hola_info.response_text);
                    error_type = error_data.error || 'general_error';
                }
                perr({id: 'www_sa2025_refund_confirmation_error',
                    info: {...perr_info, error_type}});
                set_is_loading(false);
                on_error(error_type);
            }
        });
    };
    return {on_confirm_refund, is_loading};
};

interface i_use_membership_confirmation_props {
    token: string;
    hola_uid: string;
    on_confirmed: ()=>void;
    on_error: (error_type: string)=>void;
}
export const use_membership_confirmation = (props:
    i_use_membership_confirmation_props)=>{
    const {token, hola_uid, on_confirmed, on_error} = props;
    const perr_info = {token, hola_uid};
    const [is_loading, set_is_loading] = useState(false);
    const on_confirm_membership = ()=>{
        perr({id: 'www_sa2025_membership_confirmation_click_confirm',
            info: perr_info});
        set_is_loading(true);
        etask(function*(){
            try {
                yield fetch_sa2025_redeem_token({token, hola_uid});
                perr({id: 'www_sa2025_membership_confirmation_confirmed',
                    info: perr_info});
                on_confirmed();
            } catch(e){
                let error_type = 'general_error';
                const hola_info = e.hola_info || {};
                if (hola_info.response_text)
                {
                    const error_data = JSON.parse(hola_info.response_text);
                    error_type = error_data.error || 'general_error';
                }
                perr({id: 'www_sa2025_membership_confirmation_error',
                    info: {...perr_info, error_type}});
                set_is_loading(false);
                on_error(error_type);
            }
        });
    };
    return {on_confirm_membership, is_loading};
};

export const fetch_sa2025_payout = (email: string, token: string,
    payment_method: 'paypal'|'wise', payout_email?: string)=>
    etask(function*(){
        const body:any = {email, token, payment_method, payout_email};
        yield fetch('https://hola.org/users/sa2025_payout', {
            method: 'POST',
            body,
            headers: {'Content-Type': 'application/json'},
        });
    });

interface i_use_manual_refund_props {
    hola_uid: string;
    email: string;
    token: string;
    on_success: ()=>void;
    on_error: (error_type: string)=>void;
}

export const use_payout = (props: i_use_manual_refund_props)=>{
    const {hola_uid, email, token, on_success, on_error} = props;
    const [payment_method, set_payment_method] = useState<'paypal'|'wise'>(
        'paypal');
    const [payout_email, set_payout_email] = useState(email);
    const [full_name, set_full_name] = useState('');
    const [is_loading, set_is_loading] = useState(false);
    const perr_info = {hola_uid, email, token, payment_method};
    const toggle_to_wise = ()=>{
        set_payment_method('wise');
        perr({id: 'www_sa2025_payout_toggle_to_wise', info: perr_info});
    };
    const toggle_to_paypal = ()=>{
        set_payment_method('paypal');
        perr({id: 'www_sa2025_payout_toggle_to_paypal', info: perr_info});
    };
    const submit_refund = ()=>{
        if (!payout_email)
            return;
        if (payment_method=='wise' && !full_name)
            return;
        perr({id: 'www_sa2025_payout_submit',
            info: {...perr_info, payment_method}});
        set_is_loading(true);
        etask(function*(){
            try {
                const body = {hola_uid, email, token, payment_method,
                    payout_email, ...payment_method=='wise' ?
                    {full_name} : {}};
                yield fetch('https://hola.org/users/sa2025_payout', {
                    method: 'POST',
                    body,
                    headers: {'Content-Type': 'application/json'},
                });
                perr({id: 'www_sa2025_payout_success',
                    info: {...perr_info, payment_method}});
                on_success();
            } catch(e){
                let error_type = 'general_error';
                const hola_info = e.hola_info || {};
                if (hola_info.response_text)
                {
                    const error_data = JSON.parse(hola_info.response_text);
                    error_type = error_data.error || 'general_error';
                }
                perr({id: 'www_sa2025_payout_error',
                    info: {...perr_info, error_type}});
                set_is_loading(false);
                on_error(error_type);
            }
        });
    };
    return {
        payment_method,
        payout_email,
        set_payout_email,
        full_name,
        set_full_name,
        is_loading,
        toggle_to_wise,
        toggle_to_paypal,
        submit_refund,
    };
};
